module.exports = __webpack_public_path__ + "img/1.3dc95e7d.jpg";